import { IconLabel } from '@components/icons/label';
import { FilterConfigField } from '@components/table';
import { FilterData } from '@components/table/filters';

import { useStore } from 'models/Provider';

const labelsFieldToExternalQuery = (filter: FilterData) => {
  switch (filter.comparer) {
    case 'is':
      return { labels__term: filter.value };
    case 'not_is':
    case 'none_of':
      return { labels__exclude: filter.value };
    default:
      return {
        labels__terms: Array.isArray(filter.value) ? filter.value.join('__') : filter.value,
      };
  }
};

export const useLabelsFilter = (): FilterConfigField => {
  const { t } = useStore();

  return {
    id: 'labels',
    label: t('applicants.filters.label.title'),
    icon: <IconLabel />,
    type: 'multi_select',
    values: [
      { value: 'notified', label: t('applicants.filters.label.notified') },
      { value: 'sourced', label: t('applicants.filters.label.sourced') },
      { value: 'manuallyadded', label: t('applicants.filters.label.manuallyadded') },
    ],
    allowedComparers: ['is', 'not_is', 'any_of', 'none_of'],
    toExternalQuery: labelsFieldToExternalQuery,
  };
};
